
export interface CampaignItem {
    id: string;
    title: string;
    description: string;
    image: string;
    inputText?: string;
    inputDescription?: string;
    valueType?: string
}

export const CAMPAIGN_ITEMS: CampaignItem[] = [
    {
        id: 'buyOneGetOneProduct',
        title: '1 produit acheté = 1 produit offert',
        description: 'Configurez vos offres 1 produit acheté = 1 produit offert.',
        image: require('../assets/pictures/buyOneGetOneProduct.webp').default
    },
    {
        id: 'buyOneGetOneDifferentProduct',
        title: '1 produit acheté = 1 autre produit offert',
        description: 'Configurez vos offres 1 produit acheté = 1 autre produit offert.',
        image: require('../assets/pictures/buyOneGetOneDifferentProduct.webp').default
    },
    {
        id: 'globalProductDiscountAfterThreshold',
        title: 'Réductions globales sur la carte',
        description: 'Configurez des réductions globales sur votre carte, lorsque le panier des clients dépasse le montant requis.',
        image: require('../assets/pictures/globalProductDiscountAfterThreshold.webp').default,
        inputText: 'Valeur de la réduction',
        inputDescription: 'Appliquer une réduction sur tous les produits de ',
        valueType: 'percentage'
    },

    {
        id: 'productDiscount',
        title: 'Produits en réduction',
        description: 'Configurez des produits à prix réduit pour augmenter leur attractivité.',
        image: require('../assets/pictures/productDiscount.webp').default,
        inputText: 'Valeur de la réduction',
        inputDescription: 'Appliquer une réduction sur tous les produits de ',
        valueType: 'percentage'
    },
    {
        id: 'productDiscountAfterThreshold',
        title: 'Remises produits à débloquer',
        description: 'Configurez des remises produits à débloquer, lorsque le panier des clients dépasse le montant requis.',
        image: require('../assets/pictures/productDiscountAfterThreshold.webp').default,
        inputText: 'Valeur de la réduction',
        inputDescription: 'Appliquer une réduction sur tous les produits de ',
        valueType: 'percentage'
    },
    {
        id: 'freeDeliveryAfterThreshold',
        title: 'Frais de livraison offerts',
        description: 'Configurez un montant de panier minimum pour offrir les frais de livraison à vos clients.',
        image: require('../assets/pictures/freeDeliveryAfterThreshold.webp').default
    },
    {
        id: 'fixedAmountDiscountAfterThreshold',
        title: 'Code promotionnel à débloquer',
        description: 'Configurez un montant de panier minimum pour offrir un code promotionnel à vos clients lorsque leur panier dépasse ce montant.',
        image: require('../assets/pictures/fixedAmountDiscountAfterThreshold.webp').default,
        inputText: 'Valeur du code promo',
        inputDescription: 'Appliquer un code promotionnel de',
        valueType: 'cash'

    }
];
export const BUYONEGETONEPRODUCT = 'buyOneGetOneProduct'
export const BUYONEGETONEDIFFERENTPRODUCT = 'buyOneGetOneDifferentProduct'
export const GLOBALPRODUCTDISCOUNTAFTERTHRESHOLD = 'globalProductDiscountAfterThreshold'
export const PRODUCTDISCOUNT = 'productDiscount'
export const PRODUCTDISCOUNTAFTERTHRESHOLD = 'productDiscountAfterThreshold'
export const FREEDELIVERYAFTERTHRESHOLD = 'freeDeliveryAfterThreshold'
export const FIXEDAMOUNTAFTERTHRESHOLD = 'fixedAmountDiscountAfterThreshold'
export const CAMPAIGN_WITHOUT_PRODUCT_SELECTION = [
    'fixedAmountDiscountAfterThreshold', 'freeDeliveryAfterThreshold', 'globalProductDiscountAfterThreshold'
]
export const MARKETING_CAMPAIGN_DATE_CONFLICT = 'MarketingCampaignDateConflict'
export const MARKETING_CAMPAIGN_IS_TOO_SHORT = 'MarketingCampaignIsTooShort'
export const MARKETING_CAMPAIGN_IS_ABOUT_TO_START = 'MarketingCampaignIsAboutToStart'
export const MARKETING_CAMPAIGN_PRODUCT_CONFLICT = 'MarketingCampaignProductConflict'
export const CAMPAIGN_TYPES = {
    buyOneGetOneProduct: '1 produit acheté = 1 produit offert',
    buyOneGetOneDifferentProduct: '1 produit acheté = 1 autre produit offert',
    globalProductDiscountAfterThreshold: 'Réductions globales sur la carte',
    productDiscount: 'Produits en réduction',
    productDiscountAfterThreshold: 'Remises produits à débloquer',
    freeDeliveryAfterThreshold: 'Frais de livraison offerts',
    fixedAmountDiscountAfterThreshold: 'Code promotionnel à débloquer'
}
export const MARKETING_CAMPAIGN_STATUS = {
    IN_PROGRESS: 'inProgress',
    NOT_STARTED: 'notStarted',
    CANCELED: 'canceled',
    COMPLETED: 'completed',
    PENDING: 'pending'
}

export const MARKETING_CAMPAIGN_STATUS_LABEL = {
    canceled: { label: 'Annulée', color: '#ff4861' },
    notStarted: { label: `En attente`, color: 'rgb(107 142 236 / 82%)' },
    inProgress: { label: 'En cours', color: 'rgb(243 164 6 / 88%)' },
    completed: { label: 'Terminée', color: '#4ce1b6' }
};
export const SHOPS_MODAL_TEXT = 'Définissez la liste des restaurants participant à la campagne. Attention à ne pas mélanger les cartes qui n’ont pas les mêmes références produits.'
export const CAMPAIGN_STATUS = ['En cours', 'A venir', 'Terminées'];
export const EXPANDABLE_SECTIONS = {
    LIMIT: 'limit',
    DISCOUNT: 'discount',
    THRESHOLD: 'threshold',
    PRODUCTLIST: 'productList',
    DATES: 'dates',
    HASLIMIT: 'hasLimit'
}
export const TYPES = {
    CASH: 'cash',
    PERCENTAGE: 'percentage'
}
